import EntityValidationResult from 'modules/base/dto/validation/EntityValidationResult';
import nBossConnection from 'modules/base/service/nBossConnection';

class PredictionModelEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'predictionModelEditControl';
	}

	/**
	 * @param {number} predictionTypeId
	 * @param {string} name
	 * @param {string} modelBase64
	 * @param {string} metadata
	 * @return {Promise<EntityValidationResult>}
	 */
	upload(predictionTypeId, name, modelBase64, metadata) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, { predictionTypeId, name, modelBase64, metadata })
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {string} modelBase64
	 * @param {string} metadata
	 * @return {Promise<EntityValidationResult>}
	 */
	modify(id, modelBase64, metadata) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/modify`, { id, modelBase64, metadata })
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<EntityValidationResult>}
	 */
	deleteById(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/deleteById`, { id })
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}
}

export default new PredictionModelEditService();
